import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { NavbarHorizontalStyle1Component } from 'app/layout/components/navbar/horizontal/style-1/style-1.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { ClickOutsideDirective } from 'app/shared/click-outside.directive';

@NgModule({
    declarations: [
        NavbarHorizontalStyle1Component,
        ClickOutsideDirective
    ],
    imports     : [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        FuseSharedModule,
        FuseNavigationModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        RouterModule
    ],
    exports     : [
        NavbarHorizontalStyle1Component,
        ClickOutsideDirective
    ]
})
export class NavbarHorizontalStyle1Module
{
}
